import React from 'react';
import {
    Router,
    Switch,
    Route
} from "react-router-dom";
import {history} from "./routes/Routing";
import './App.css';
import {PrivateRoute, AdminPrivateRoute} from "./authentication/ProtectedRoute";
import Home from "./components/home/Home";
import Trypi from "./components/trypi/Trypi";
import Nav from "./components/header/Nav";
import Admin from "./components/adminPanel/Admin";
import Pisaas from "./components/pisaas/Pisaas";
import Academy from "./components/academy/Academy";
import TrypiProvider from "./context/trypiProvider";

const App = () => {

    return (
        <TrypiProvider>
            <div>
                <Nav/>
                <Router history={history}>
                    <Switch>
                        <Route path="/" exact component={Home}/>
                        <PrivateRoute path="/trypi" component={Trypi}/>
                        <PrivateRoute path="/instances" component={Trypi}/>
                        <PrivateRoute path="/academy" component={Academy}/>
                        <PrivateRoute path="/pisaas" component={Pisaas}/>
                        <AdminPrivateRoute path="/admin" component={Admin}/>
                    </Switch>
                </Router>
            </div>
        </TrypiProvider>
    );
}

export default App;
